import axios from "axios";

export const API_INTERNAL_URL = "http://143.198.5.94:8080";

const { REACT_APP_MY_ENV } = process.env;

const axiosInstance = axios.create({
  baseURL: REACT_APP_MY_ENV,
});

function authorizationHeaders() {
  const session = JSON.parse(sessionStorage.getItem("token_store") || "{}");
  return { Authorization: `Bearer ${session.token || "empty"}` };
}

export function getProfilePreferences() {
  return axiosInstance.get("/client/profile/preferences", {
    headers: authorizationHeaders(),
  });
}

export function saveProfilePreferences(preferences) {
  return axiosInstance.put("/client/profile/preferences", preferences, {
    headers: authorizationHeaders(),
  });
}

// Handle user session
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (status === 401 || status === 409) {
      sessionStorage.removeItem("token_store");
      window.location.href = "/auth/sign-in";
    }
    return Promise.reject(error);
  }
);
export const updateInfoProfile = (userData) => {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "put",
      url: "/client/registry/",
      headers: {
        put: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
          "Content-Type": "application/json",
        },
      },
      data: {
        firstName: userData.firstName,
        lastName: userData.lastName,
        phoneNumber: userData.phoneNumber,
        mobileNumber: userData.mobileNumber,
        streetAddress: userData.streetAddress,
        email: userData.email,
        profilePicture: userData.photo,
      },
    })
      .then((response) => {
        if (
          response.status === 200 ||
          response.status === 202 ||
          response.status === 201
        ) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

export function getClientBankInfo() {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "get",
      url: "/client/bank/info",
      headers: {
        get: {
          Authorization:
            "Bearer " +
            JSON.parse(
              sessionStorage.hasOwnProperty("token_store")
                ? sessionStorage.getItem("token_store")
                : JSON.stringify({ token: "empty" })
            ).token,
        },
      },
    })
      .then((response) => {
        if (
          response.status === 200 ||
          response.status === 201 ||
          response.status === 204
        ) {
          resolve(response);
        }
        reject(response);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
